import { iResponseAuthTokens, iAuthTokens } from '~source/core/models';

export function transformAuthTokens(value: iResponseAuthTokens): iAuthTokens {
    return {
        authToken: value.authToken,
        refreshToken: value.refreshToken,
    };
}
